<template>
<section class="main-footer">
    <Contact/>
    <div class="divider white"></div>
    <div class="sloth-container">
        <SimpleFooter/>
    </div>
</section>
</template>

<script>
import Contact from './../sections/Contact';
import SimpleFooter from './SimpleFooter';
export default {
    name: "MainFooter",
    components: {
        Contact,
        SimpleFooter
    }
    
};
</script>
